/*eslint-disable*/
import { GET_METHOD, POST_METHOD, PUT_METHOD, DELETE_METHOD, PATCH_METHOD } from "../../userActivities.constants";
function hasNumber(myString) {
    return /\d/.test(myString);
}

const METHOD_TO_LABEL_MAP = {
    [GET_METHOD.value] : 'Fetch',
    [POST_METHOD.value] : 'Create',
    [PUT_METHOD.value] : 'Update',
    [DELETE_METHOD.value] : 'Delete',
    [PATCH_METHOD.value] : 'Patch',
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

const getPrefix = activity => {
    const method = activity.method;
    return METHOD_TO_LABEL_MAP[method];
}

const getSuffix = (activity) => {
    const url = activity.url;
    const types = url.split('/');
    const typesLength = types.length;
    let suffix = types[typesLength -1];
    if(hasNumber(types[typesLength -1])) {
        suffix = types[typesLength-2];
    }
    return capitalizeFirstLetter(suffix);
}

export const getTransactionDetail = activity => {
    const url = activity.url || '';
    const method = activity.method;
    const userIdRegex = /\/users\/[^\/]+$/;
    const groupIdRegex = /\/groups\/[^\/]+$/;
    const appIdRegex = /\/apps\/[^\/]+$/;
    const usersByGroupRegex = /\/groups\/[^\/]+\/users$/;
    const groupsByUserRegex = /\/users\/[^\/]+\/groups$/;
    const userByGroupRegex = /\/groups\/[^\/]+(?:\/users\/[^\/]+)*$/;
    if(url.endsWith('/users/upsert')) return 'Created Upsert';
    if(url.endsWith('/introspect')) return 'Sign In';
    if(url.endsWith('/lifecycle/activate')) return 'Sent activation email';
    if(url.endsWith('/lifecycle/reactivate')) return 'Sent re-activation email';
    if(url.endsWith('/lifecycle/deactivate')) return 'Deactivated User';
    if(url.endsWith('/lifecycle/reset_password')) return 'Sent reset password';
    if(url.endsWith('/lifecycle/forgot_password')) return 'Forgot password- Reset';
    if(url.endsWith('/lifecycle/suspend')) return 'Suspended user account';
    if(url.endsWith('/lifecycle/unsuspend')) return 'Unsuspended user account';
    if(url.endsWith('/lifecycle/unlock')) return 'Unlocked user acount';
    if(url.endsWith('/lifecycle/expire_password')) return 'Deleted user password';
    if(url.endsWith('/entitlement-bundles')) return 'Created entitlement-bundles'
    if(url.includes('users/') && url.includes('/bulk-upload-status')) return 'Checked bulk upload status'
    if(url.includes('/users/bulk-upload')) return 'Uploaded Bulk users';
    if(url.endsWith('/lifecycle/activate?sendEmail=true')) return 'Sent activation email';

    if(method === POST_METHOD.value && url.endsWith('users/bulk-upload')) return 'Uploaded bulk users';
    if(method === GET_METHOD.value && url.includes('users/bulk-upload')) return 'Fetched user details of bulkUpload';
    if(method === PUT_METHOD.value && userByGroupRegex.test(url)) return 'Updated User By Group';
    if(method === GET_METHOD.value && usersByGroupRegex.test(url)) return 'Fetched user details from Group members';
    if(method === GET_METHOD.value && groupsByUserRegex.test(url)) return 'Feteched Groups from user details';
    if(method === GET_METHOD.value && userIdRegex.test(url)) return 'Searched User By Id';
    if(method === GET_METHOD.value && groupIdRegex.test(url)) return 'Search Group By Id';
    if(method === GET_METHOD.value && appIdRegex.test(url)) return 'Searched App By Id';
    if(method === GET_METHOD.value && userIdRegex.test(url)) return 'Searched User By Id';
    if(method === PUT_METHOD.value && userIdRegex.test(url)) return 'Updated User details';
    if(method === PUT_METHOD.value && userIdRegex.test(url)) return 'Updated Group details';
    if(method === PUT_METHOD.value && userIdRegex.test(url)) return 'Updated App details';
    if(method === GET_METHOD.value && url.includes('/users')) return 'Searched Users';
    if(method === GET_METHOD.value && url.includes('/apps')) return 'Searched Applications';
    if(method === GET_METHOD.value && url.includes('/groups')) return 'Searched Groups';
    if(method === GET_METHOD.value && url.includes('/audits')) return 'Searched Audits';
    if(method === GET_METHOD.value && url.includes('/campaigns')) return 'Searched Campaigns';
    if(method === GET_METHOD.value && url.includes('/entitlements')) return 'Searched Enititlements';
    if(method === GET_METHOD.value && url.includes('/principal-entitlements')) return 'Searched  prinicipal Enititlements';
    if(method === POST_METHOD.value && url.includes('/users')) return 'Created/Updated User';
    if(method === POST_METHOD.value && url.includes('/apps')) return 'Created App';
    if(method === POST_METHOD.value && url.includes('/groups')) return 'Created Group';
    if(method === POST_METHOD.value && url.includes('/campaigns')) return 'Created Campaign';
    if(method === POST_METHOD.value && url.includes('/entitlements')) return 'Created Entitlement';
    if(method === POST_METHOD.value && url.includes('/grants')) return 'Created Grants';
    if(method === PATCH_METHOD.value && url.includes('/groups')) return 'Updated Group';
    if(method === PATCH_METHOD.value && url.includes('/users')) return 'Updated User';
    if(method === PATCH_METHOD.value && url.includes('/apps')) return 'Updated Application';


    return `${getPrefix(activity)} ${getSuffix(activity)}`
}

const sortByDate = (a, b) => {
    return a.timeStamp - b.timeStamp;
  };

export const sortUserActivities = ({ userActivities, sortBy, sortOrder }) => [...userActivities].sort((a, b) => {
    const isAsc = sortOrder === 'asc';
    if(sortBy == "timeStamp") {
       return isAsc ? new Date(a.timeStamp) - new Date(b.timeStamp) : new Date(b.timeStamp) - new Date(a.timeStamp)
    }
    return isAsc ? a[sortBy].localeCompare(b[sortBy]) : b[sortBy].localeCompare(a[sortBy]);
});